import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		root: {
			borderBottom: "1px solid rgba(0, 0, 0, .05)",
			"&:hover": {
				backgroundColor: "rgba(0, 0, 0, .05)",
				"& .showOnHover": {
					visibility: "visible",
				},
			},
			"& .showOnHover": {
				visibility: "hidden",
			},
		},
	} satisfies Record<string, CSSObject>);
};
